import {useEffect, useEffectEvent, useState} from 'react';
import type {Data, Schema, Valid} from 'schemaDefinition/types';
import type {CodeListMap} from 'services/codelists/types';
import {validate} from 'schema/form/functions/validators';
import {useAssertExpressionEdit} from './useAssertExpressionEdit';

export const useExpressionValidation = (
  expressionId: string,
  relatedScope: Data,
  showErrors: boolean,
  schema: Schema,
  codelistMap: CodeListMap,
): Valid | undefined => {
  const expression = useAssertExpressionEdit(expressionId);
  const [valid, setValid] = useState<Valid | undefined>(undefined);
  const onSetValid = useEffectEvent(setValid);

  useEffect(() => {
    if (showErrors) {
      const validation = validate(
        expression,
        relatedScope,
        schema,
        codelistMap,
      );

      onSetValid(validation.valid);
    } else {
      onSetValid(undefined);
    }
  }, [expression, schema, codelistMap, showErrors, relatedScope]);

  return valid;
};
